import React, { useCallback, useState } from 'react';

import { MdPlayArrow } from 'react-icons/md';
import { Formik } from 'formik';
import { IoMdArrowForward, IoMdArrowBack } from 'react-icons/io';
import * as Yup from 'yup';
import { toast } from 'react-toastify';
import { Link } from 'react-router-dom';
import TextField from 'components/layout/form/textField';
import ContainedButton from 'components/layout/form/containedButton';
import OutlinedButton from 'components/layout/form/outlinedButton';
import { passwordRegex } from 'utils/regex';
import api from 'services/api';
import { useMediaQuery } from 'react-responsive';

import CustomToolip from './CustomToolip';
import PasswordForceMobile from './PasswordForceMobile';

import {
  Container,
  ContainerButtons,
  FormContainer,
  ContainerForm,
  WrapSearchDocument,
  SearchDocumentText,
  SearchDocumentIcon,
} from './styles';
import { HeaderContainer } from '../styles';

const NewPassword = ({ step, setStep, useInfo, setUseInfo }) => {
  const [loading, setLoading] = useState(false);
  const [showPasswordForce, setShowPasswordForce] = useState(false);

  const showMobileMode = useMediaQuery({ maxWidth: 959 });

  const validationSchema = () =>
    Yup.object().shape({
      password: Yup.string()
        .required('Insira uma senha')
        .matches(
          passwordRegex,
          'Use o mínimo de 8 caracteres, com uma combinação de letras maiúsculas, minúsculas, números e símbolos.'
        ),
      passwordConfirmation: Yup.string()
        .required('Insira a confirmação de sua senha')
        .oneOf([Yup.ref('password'), null], 'As senhas não combinam'),
    });

  const handleSubmit = useCallback(
    async ({ password, passwordConfirmation }) => {
      setLoading(true);
      const { search } = window.location;
      const params = new URLSearchParams(search);
      const token = params.get('token');
      const userId = params.get('user-id');

      const header = {
        'Content-Type': 'application/json',
        'Accept-Language': 'pt-BR',
        Authorization: process.env.REACT_APP_SIGNIN_AUTHORIZATION,
      };
      const parameters = {
        method: 'PATCH',
        headers: header,
      };
      const body = {
        password,
        passwordConfirmation,
        token,
      };
      api
        .patch(`industrial/customer/v1/users/${userId}`, body, parameters)
        .then((res) => {
          const tokenMFA = res.headers['x-mfa-hash'];

          if (tokenMFA) {
            localStorage.setItem('@UltragazEmpresarial:X-Mfa-Hash', tokenMFA);
          }
          setLoading(false);
          if (res.status === 204) {
            setStep(4);
          }
        })
        .catch((err) => {
          setLoading(false);
          if (err.response.data.code === '422.002') {
            toast.error('Seu link de redefinição de senha está expirado.');
          } else {
            const { message } = err.response.data;
            if (message) {
              if (err.response.status !== 401) {
                toast.error(message);
              }
            } else if (err.response.status !== 401) {
              toast.error('Ocorreu um erro interno na aplicação');
            }
          }
        });
    },
    [api]
  );

  const handleShowPasswordForce = useCallback(() => {
    setShowPasswordForce(!showPasswordForce);
  }, [showPasswordForce]);

  return (
    <Container>
      <HeaderContainer>
        <h1>Estamos quase lá!</h1>
        <h2>Defina sua nova senha </h2>
      </HeaderContainer>

      <Formik
        initialValues={{
          token: '',
          password: '',
          passwordConfirmation: '',
        }}
        onSubmit={(values) => {
          handleSubmit(values);
        }}
        validationSchema={validationSchema}
        render={({ handleChange, handleBlur, values, errors, touched }) => (
          <FormContainer>
            <ContainerForm>
              <div>
                <TextField
                  id="password"
                  name="password"
                  label="Nova senha"
                  aria-label="Nova senha"
                  aria-required
                  errorCondition={errors.password && touched.password}
                  errorMessage={errors.password}
                  showChangeTextPassword
                  onBlur={handleBlur}
                  placeholder="Nova senha"
                  value={values.password}
                  onChange={handleChange}
                />
                <WrapSearchDocument>
                  {!showMobileMode && (
                    <CustomToolip title="Requisitos de Senha">
                      <SearchDocumentText>
                        Requisitos de senha
                      </SearchDocumentText>
                      <SearchDocumentIcon>!</SearchDocumentIcon>
                    </CustomToolip>
                  )}
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'flex-end',
                    }}
                  >
                    {showMobileMode && (
                      <div
                        style={{
                          display: 'flex',
                        }}
                        onClick={handleShowPasswordForce}
                      >
                        <SearchDocumentText>
                          Requisitos de senha
                        </SearchDocumentText>
                        <SearchDocumentIcon>!</SearchDocumentIcon>
                      </div>
                    )}

                    {showMobileMode && showPasswordForce && (
                      <PasswordForceMobile />
                    )}
                  </div>
                </WrapSearchDocument>
              </div>

              <div>
                <TextField
                  id="passwordConfirmation"
                  name="passwordConfirmation"
                  label="Confirmação de Senha"
                  aria-label="Confirmação de Senha"
                  aria-required
                  errorCondition={
                    errors.passwordConfirmation && touched.passwordConfirmation
                  }
                  errorMessage={errors.passwordConfirmation}
                  showChangeTextPassword
                  onBlur={handleBlur}
                  placeholder="Confirme a senha"
                  value={values.passwordConfirmation}
                  onChange={handleChange}
                />
              </div>
            </ContainerForm>

            <ContainerButtons>
              <ContainedButton
                type="submit"
                loading={loading}
                id="Avançar"
                width="100%"
                TrailingIcon={() => <IoMdArrowForward size={20} />}
              >
                Continuar
              </ContainedButton>

              <Link to="/esqueci-senha" style={{ textDecoration: 'none' }}>
                <OutlinedButton
                  width="100%"
                  LeadingIcon={() => <IoMdArrowBack size={20} />}
                >
                  Voltar
                </OutlinedButton>
              </Link>
            </ContainerButtons>
          </FormContainer>
        )}
      />
    </Container>
  );
};

export default NewPassword;
